module.exports = __webpack_public_path__ + "yellow.e05a1b1572b504488868.png";